module.exports = __webpack_public_path__ + "static/img/circle-1.600e7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/circle-1.png
// module id = oWzO
// module chunks = 0